export const categories = ["Tất cả", "Vòng đá cao cấp", "Dây chuyền", "Vòng đá thiết kế"];